import amplitude from 'amplitude-js';
import { AMPLITUDE_KEY } from 'config';

class amplitudeService {
  constructor() {
    this.isInit = false;
  }

  init = () => {
    amplitude.getInstance().init(AMPLITUDE_KEY);
    this.isInit = true;
  };

  track = (name, properties = {}, callback) => {
    if (!this.isInit) this.init();
    amplitude.getInstance().logEvent(name, { ...properties }, callback);
  };

  couponPageview = (coupon, source) => {
    this.track('序號兌換-車牌頁-Pageview', {
      coupon_id: coupon.id,
      name: coupon.attributes.campaign,
      source,
    });
  };

  couponSerialCodeOnClick = (coupon, source) => {
    this.track('序號兌換-輸入序號_點擊', {
      coupon_id: coupon.id,
      name: coupon.attributes.campaign,
      source,
    });
  };

  couponPlateNumberOnClick = (coupon, source) => {
    this.track('序號兌換-輸入車牌_點擊', {
      coupon_id: coupon.id,
      name: coupon.attributes.campaign,
      source,
    });
  };

  verifyOnClick = (state, plateNumber, serialCode, coupon, source, errorCode = null) => {
    this.track('序號兌換-填車牌拿優惠_點擊', {
      state,
      plate_number: plateNumber,
      coupon_code: serialCode,
      coupon_id: coupon.id,
      name: coupon.attributes.campaign,
      source: source,
      error_code: errorCode,
    });
  };

  couponMobileOnClick = (coupon, source) => {
    this.track('序號兌換-輸入手機_點擊', {
      coupon_id: coupon.id,
      name: coupon.attributes.campaign,
      source,
    });
  };

  couponEmailOnClick = (coupon, source) => {
    this.track('序號兌換-輸入email_點擊', {
      coupon_id: coupon.id,
      name: coupon.attributes.campaign,
      source,
    });
  };

  completeOnClick = (state, mobile, email, coupon, source, errorCode = null) => {
    this.track('序號兌換-完成抽獎資格_點擊', {
      state,
      mobile,
      email,
      coupon_id: coupon.id,
      name: coupon.attributes.campaign,
      source: source,
      error_code: errorCode,
    });
  };

  continueOnClick = (state, mobile, email, coupon, source, errorCode = null) => {
    this.track('序號兌換-繼續兌換_點擊', {
      state,
      mobile,
      email,
      coupon_id: coupon.id,
      name: coupon.attributes.campaign,
      source: source,
      error_code: errorCode,
    });
  };

  shareOnClick = (type, mobile, email, coupon, source) => {
    this.track('序號兌換-完成抽獎資格-分享_點擊', {
      state: 'success',
      mobile,
      email,
      coupon_id: coupon.id,
      name: coupon.attributes.campaign,
      source,
      分享類型: type,
    });
  };
}

export default new amplitudeService();
